import $ from 'jquery'
import { dateFormat } from '@/utils'
import { getLocalStore } from '@/utils/common'

export default {
  computed: {
    server() {
      return 'https://www.beeftochina.com.cn/StaticFiles/'
      // return 'http://192.168.10.52:5000/StaticFiles/'
    },
    isEN() {
      return this.$i18n.locale === 'en'
    },
    isLogin() {
      return this.$store.getters.token
    },
    today() {
      return dateFormat('YYYY-mm-dd', new Date())
    },
    expiry() {
      return dateFormat('YYYY-mm-dd', new Date(getLocalStore().ChargeExpireDate))
    },
    expiryEn() {
      return dateFormat('YYYY-mm-dd', new Date(getLocalStore().ChargeEnExpireDate))
    },
    canVisitModel() {
      return getLocalStore().CanVisitModule.includes('_btcdata')
    },
    canVisitModelEn() {
      return getLocalStore().CanVisitModuleEn.includes('_btcdata_en')
    },
    canVisitPorkModel() {
      return getLocalStore().CanVisitModule.includes('_porkdata')
    },
    canVisitPorkModelEn() {
      return getLocalStore().CanVisitModuleEn.includes('_porkdata_en')
    },
    canVisitPorkEst() {
      return getLocalStore().CanVisitModule.includes('_porkest')
    },
    canVisitPorkEstEn() {
      return getLocalStore().CanVisitModuleEn.includes('_porkest_en')
    },
    canVisitPrice() {
      return getLocalStore().CanVisitModule.includes('_beefpriceindex')
    },
    canVisitPriceEn() {
      return getLocalStore().CanVisitModuleEn.includes('_beefprice_en')
    },
    canVisitFactoryCn() {
      return getLocalStore().CanVisitModule.includes('_btcfactory')
    },
    canVisitEstEn() {
      return getLocalStore().CanVisitModule.includes('_btcest_en')
    }
  },
  methods: {
    // 获取附件地址
    getUrl(item) {
      return this.server + item.AppendixAddr
    },
    // 登录弹窗
    openLoginModal() {
      $('#loginModel').modal('show')
    },
    closeLoginModal() {
      $('#loginModel').modal('hide')
    },
    // 续费提醒弹窗
    openRenewalModal() {
      $('#renewalModal').modal('show')
    },
    closeRenewalModal() {
      $('#renewalModal').modal('hide')
    },
    // 试用弹窗
    openTrialModal() {
      $('#trialModel').modal('show')
    },
    closeTrialModal() {
      $('#trialModel').modal('hide')
    },
    // 截取时间
    getTime(time) {
      return time ? time.substring(0, 10) : ''
    },
    openNewWindow(path) {
      const routeData = this.$router.resolve({ path: path })
      const open = window.open(routeData.href, '_blank')
      if (open === null || typeof (open) === 'undefined') {
        this.$router.push(path)
      }
    },
    isDisabledMonth(year, month, targetMonth) {
      return year >= 2020 && month > targetMonth
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/commonmix.js